import {useContext} from "react";
import {LocationContext} from "./location-context-props.ts";

const useLocationContext = () => {
    const context = useContext(LocationContext);
    if(!context) {
        throw new Error('useLocationContext must be used within a LocationContextProvider');
    }
    return context;
}

export default useLocationContext;